import React from 'react'
import Footer from './Footer'
import Navbar from './Navbar'

export default function Impressum() {
  return (
    <div className="min-h-screen bg-black text-white">
      <Navbar request="impressum"  />

      <main className="lg:mx-[15rem] px-6 py-[10rem] space-y-6">
        <h1 className="text-2xl font-bold mb-4">Impressum</h1>

        <p>
          <strong>Bustos Automobile GmbH</strong>
        </p>

        <div>
          <p><strong>E-Mail:</strong> info@bustosautomobile.ch</p>
          <p><strong>Web:</strong> www.bustosautomobile.ch</p> 
        </div>

        <div>
          <h2 className="text-xl font-semibold mt-6 mb-2">Vertretungsberechtigte Geschäftsführer*innen Bustos Automobile GmbH</h2>
          <ul className="list-disc list-inside space-y-1">
            <li>Antonio Bustos Lopez</li>
          </ul>
        </div>

        <div className="mt-6">
          <p><strong>Handelsregister-Nr.:</strong>CH-020.4.073.679-5</p>
          <p><strong>Rechtsform:</strong> GmbH</p>
          <p><strong>Branche:</strong> Automobilhandel</p>
        </div>
      </main>

      <Footer />
    </div>
  )
}
